import { CategoriesTreeLevel } from "@features/graph/GraphCategories"
import { getCategoryLevelPath } from "@features/graph/GraphCategories.utils"
import { ArrowBack, Home, NavigateNext } from "@mui/icons-material"
import { Box, Breadcrumbs, Grid, IconButton, Tooltip } from "@mui/material"
import { Link, useLocation, useSearchParams } from "react-router"

type GraphCategoriesNavigationBarProps = {
  tree: CategoriesTreeLevel[]
  currentLevel: CategoriesTreeLevel | undefined
}

const GraphCategoriesNavigationBar = (props: GraphCategoriesNavigationBarProps) => {
  const location = useLocation()
  const [, setSearchParams] = useSearchParams()

  const currentLevelId = props.currentLevel?.groupId || "root"
  const breadcrumbLevels = getCategoryLevelPath(currentLevelId, props.tree)

  const handleBackCategoryClick = () => {
    if (!props.currentLevel?.parentId) return

    setSearchParams((params) => {
      params.set("categoryId", props.currentLevel!.parentId!)
      return params
    })
  }

  return (
    <Grid container spacing={4} alignItems="center">
      <Grid item>
        <Tooltip title="Back">
          <span>
            <IconButton
              disabled={!props.currentLevel?.parentId}
              onClick={handleBackCategoryClick}
              data-testid="category-view-breadcrumb-back"
            >
              <ArrowBack />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>

      <Grid item>
        <Breadcrumbs separator={<NavigateNext />} data-testid="category-view-breadcrumb-bar">
          {breadcrumbLevels.map((level) => {
            const updatedParams = new URLSearchParams(location.search)
            updatedParams.set("categoryId", level.groupId)
            const breadcrumbLabel = level.groupId === "root" ? "Home" : level.label

            return (
              <Box key={level.groupId} sx={{ ":hover": { textDecoration: "underline" } }}>
                <Link
                  data-breadcrumb-label={breadcrumbLabel}
                  preventScrollReset
                  to={{
                    pathname: location.pathname,
                    search: updatedParams.toString(),
                    hash: location.hash,
                  }}
                  style={{ color: "inherit", textDecoration: "inherit" }}
                >
                  {level.groupId === "root" ? <Home sx={{ verticalAlign: "sub" }} /> : level.label}
                </Link>
              </Box>
            )
          })}
        </Breadcrumbs>
      </Grid>
    </Grid>
  )
}

export default GraphCategoriesNavigationBar
